import React, { createContext, useContext, useState, useCallback } from 'react'

interface ChatbotContextType {
  isChatbotVisible: boolean
  setIsChatbotVisible: (visible: boolean) => void
}

const ChatbotContext = createContext<ChatbotContextType | undefined>(undefined)

export const ChatbotProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isChatbotVisible, setIsChatbotVisibleState] = useState(true)
  const setIsChatbotVisible = useCallback((visible: boolean) => setIsChatbotVisibleState(visible), [])

  return (
    <ChatbotContext.Provider value={{ isChatbotVisible, setIsChatbotVisible }}>
      {children}
    </ChatbotContext.Provider>
  )
}

export const useChatbot = () => {
  const context = useContext(ChatbotContext)
  if (context === undefined) {
    throw new Error('useChatbot must be used within a ChatbotProvider')
  }
  return context
} 